import { Field, Form, Formik } from "formik"; // Importing Formik components for form handling
import { observer } from "mobx-react"; // Importing MobX observer for state management
import { Button, Modal } from "react-bootstrap"; // Importing Bootstrap components
import { FormattedMessage } from "react-intl"; // Importing for internationalization
import LoaderButton from "../../../../shared-components/button/loader-button"; // Custom loader button component
import FormLoader from "../../../../shared-components/FormLoader/FormLoader"; // Custom form loader component
import Label from "../../../../shared-components/label/label"; // Custom label component
import CancelReservationPopupHOC from "../hoc/cancel-reservation-popup-hoc"; // Higher-order component for cancel reservation popup

interface IProps {
  isLoading: boolean; // Indicates if the form is in loading state
  submitCancelHandler: (data: any) => void; // Handler for form submission
  onModalClosed: () => void; // Handler for closing the modal
}

const CancelReservationForm = (props: IProps) => {
  const handleSubmit = (values: any, { setSubmitting }: any) => {
    props.submitCancelHandler(values); // Call the submit handler with form values
    setSubmitting(false); // Stop the form submission state
  };

  return (
    <Modal show={true} className="cancelation-modal" centered size="sm">
      {" "}
      {/* Modal for cancel reservation */}
      <Modal.Header>
        <Modal.Title>
          <FormattedMessage id="cancel_reservation" /> {/* Modal title */}
          <button
            onClick={props.onModalClosed} // Close modal on button click
            disabled={props.isLoading} // Disable button if loading
            className="Crossicons"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="23"
              height="23"
              fill="currentColor"
              className="bi bi-x"
              viewBox="0 0 16 16"
            >
              <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />{" "}
              {/* Close icon */}
            </svg>
          </button>
        </Modal.Title>
      </Modal.Header>
      <Formik
        initialValues={{ CancellationType: "1" }} // Initial form values
        enableReinitialize // Reinitialize form values when props change
        onSubmit={handleSubmit} // Form submission handler
      >
        {({ isSubmitting }) => (
          <Form className="user-form">
            {" "}
            {/* Formik form */}
            {props.isLoading && <FormLoader loading={props.isLoading} />}{" "}
            {/* Show loader if loading */}
            <Modal.Body>
              <div>
                <Label className="label-style" label="cancellation_type" />{" "}
                {/* Label for cancellation type */}
                <div className="row">
                  <div className="col-sm-6">
                    <Field
                      className="form-check-input" // Radio button for "By Call"
                      name="CancellationType"
                      type="radio"
                      value="1"
                      id="by_call"
                    />
                    <label className="form-check-label" htmlFor="by_call">
                      <FormattedMessage id="by_call" />{" "}
                      {/* Label for "By Call" */}
                    </label>
                  </div>
                  <div className="col-sm-6">
                    <Field
                      className="form-check-input" // Radio button for "By Visit"
                      name="CancellationType"
                      type="radio"
                      value="2"
                      id="by_visit"
                    />
                    <label className="form-check-label" htmlFor="by_visit">
                      <FormattedMessage id="by_visit" />{" "}
                      {/* Label for "By Visit" */}
                    </label>
                  </div>
                </div>
              </div>
            </Modal.Body>
            <div className="modal-footer center-content">
              <Button
                variant="outline-danger" // Close button
                type="button"
                onClick={props.onModalClosed} // Close modal on button click
                disabled={props.isLoading} // Disable button if loading
              >
                <i className="bi bi-x-lg me-1"></i> {/* Close icon */}
                <FormattedMessage id="close" /> {/* Close button text */}
              </Button>

              <LoaderButton
                type="submit" // Submit button
                iconName="bi-check-lg" // Submit icon
                isLoading={props.isLoading} // Show loader if loading
                text={"button_save"} // Submit button text
              />
            </div>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};

export default CancelReservationPopupHOC(observer(CancelReservationForm)); // Exporting the component wrapped with HOC and observer
